class BaseClient {
  isWithinOnlineStore() {
    return false;
  }
}

if (typeof window !== "undefined" && typeof window.convertflow == "undefined") {
  window.BaseClient = BaseClient;
}
